export default {
    StuartBlue: '#11a3eb',
    DarkBlue: '#1F2933',
    Blue: '#1A5778',
    Yellow: '#FFB11F',
    Grey: '#8F96A0',
    White: '#f8f9fa',
    LightGrey: '#f0f3f7',
    GreyLightest: '#F5F6F7',
    CardGrey: '#DADEE2',
    AlmostWhite: '#FAFAFA',
    StuartNewBlue: '#3C93F7',
    StuartNewDarkBlue: '#032896',
    StuartNewGreen: '#6CDEA9',
    StuartNewYellow: '#F8CC57',
    StuartNewCoral: '#EC5B75',
    StuartNewLightBlue: '#9EE8FC',
    StuartNewPurple: '#475BF6',
};
